import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class Procedure extends ConnectBasicEntityExt {
bddSourceCode: string;
description: TranslatedEmb;
label: TranslatedEmb;
parametersCode: string;
returnKind: string;
sourceCode: string;
vision: string;
}

